export const LINK_BOT_AGENT_META = {
  'Lease Schedule': {
    initial: 'L',
    description: 'Automates lease abstraction by extracting key terms, dates, and clauses from lease agreements.',
  },
  'Borrowing Schedule': {
    initial: 'B',
    description: 'Extracts and organizes borrowing details including rates, maturities, and covenants from credit agreements.',
  },
  'Transaction Matching': {
    initial: 'T',
    description: 'Matches and reconciles transactions across multiple data sources to identify discrepancies.',
  },
  Accruals: {
    initial: 'A',
    description: 'Estimates accruals from open purchase orders and lets the task preparer review that location.',
  },
};

function normalizeBotListItem(item) {
  if (typeof item === 'string') {
    return { name: item, value: item };
  }

  if (item && typeof item === 'object') {
    const name = item.name || item.value || item.label || '';
    const value = item.value || item.name || item.label || '';
    return { name, value };
  }

  return { name: '', value: '' };
}

export function getLinkBotAgentOptions(botList = []) {
  const seen = new Set();

  return (botList || [])
    .map(normalizeBotListItem)
    .filter((item) => item.value)
    .filter((item) => {
      if (seen.has(item.value)) return false;
      seen.add(item.value);
      return true;
    })
    .map(({ name, value }) => {
      const meta = LINK_BOT_AGENT_META[value] || LINK_BOT_AGENT_META[name] || {};
      return {
        name,
        value,
        initial: meta.initial || String(name || value || '?').charAt(0).toUpperCase(),
        description: meta.description || '',
      };
    });
}
